import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const PinterestAd = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14923)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#BFCDFF"
          />
          <rect
            x="59.75"
            y="22.75"
            width="41.5"
            height="67.5"
            rx="7.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="72.2305"
            y="27"
            width="17.641"
            height="2"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="74.75"
            y="38.75"
            width="90.5"
            height="79.5"
            rx="1.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="74"
            y="77"
            width="92"
            height="2"
            fill="#1E1E1E"
          />
          <rect
            x="74"
            y="46"
            width="92"
            height="1.5"
            fill="#1E1E1E"
          />
          <rect
            x="81"
            y="62"
            width="77"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="81"
            y="69"
            width="61"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="93"
            y="54"
            width="19"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <circle
            cx="85"
            cy="55"
            r="4"
            fill="#8C8C8C"
          />
          <circle
            cx="151.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="156.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="161.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="127"
            cy="90"
            r="3"
            fill="#0C5CEF"
          />
          <path
            d="M115.296 88.5799C115.396 88.4398 115.604 88.4398 115.704 88.5799L132.265 111.855C132.383 112.021 132.264 112.25 132.061 112.25H98.9388C98.7357 112.25 98.6174 112.021 98.7351 111.855L115.296 88.5799Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M129.797 96.5616C129.897 96.4234 130.103 96.4234 130.203 96.5616L141.247 111.854C141.366 112.019 141.248 112.25 141.044 112.25H118.956C118.752 112.25 118.634 112.019 118.753 111.854L129.797 96.5616Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M169 36.9998C169 43.1419 172.694 48.4185 177.979 50.7384C177.937 49.691 177.971 48.4336 178.24 47.294C178.528 46.0763 180.17 39.1206 180.17 39.1206C180.17 39.1206 179.691 38.1629 179.691 36.7474C179.691 34.5245 180.979 32.8644 182.584 32.8644C183.948 32.8644 184.607 33.8892 184.607 35.1163C184.607 36.4878 183.732 38.5394 183.283 40.4395C182.907 42.0307 184.08 43.3285 185.65 43.3285C188.492 43.3285 190.406 39.6783 190.406 35.3535C190.406 32.066 188.192 29.6054 184.165 29.6054C179.614 29.6054 176.78 32.9986 176.78 36.7888C176.78 38.0956 177.165 39.0172 177.769 39.7308C178.046 40.0586 178.085 40.1904 177.984 40.5668C177.912 40.8428 177.747 41.5072 177.679 41.7705C177.579 42.1504 177.271 42.2862 176.928 42.146C174.832 41.2904 173.856 38.9954 173.856 36.4154C173.856 32.1545 177.449 27.0453 184.576 27.0453C190.303 27.0453 194.073 31.1894 194.073 35.6378C194.073 41.522 190.801 45.9179 185.979 45.9179C184.359 45.9179 182.836 45.0425 182.314 44.0482C182.314 44.0482 181.444 47.5042 181.259 48.1716C180.941 49.3281 180.319 50.484 179.749 51.3849C181.098 51.7831 182.524 52 184.001 52C192.284 52 199 45.2843 199 36.9998C199 28.7157 192.284 22 184.001 22C175.716 22 169 28.7157 169 36.9998Z"
            fill="#CB1F27"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14923">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
PinterestAd.displayName = 'PinterestAd';
